import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Logistiques } from '../../logistiques';
import { LogistiquesService } from '../../logistiques.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-parc-auto-chauffeur',
  templateUrl: './parc-auto-chauffeur.component.html',
  styleUrls: ['./parc-auto-chauffeur.component.css']
})
export class ParcAutoChauffeurComponent implements OnInit, OnDestroy {
  user = JSON.parse(localStorage.getItem('user'));
  subscription = new Subscription();
  @Input() id: string;
  v: Logistiques;
  form: FormGroup;
  submitted = false;
  loading = true;
  errorMsg = '';
  errorLoading = '';

  constructor(
    private modal: NgbModal,
    private fb: FormBuilder,
    private service: LogistiquesService
  ) { }

  ngOnInit(): void {
    this.getVehicule(this.id);
    this.createForm();
  }

  getVehicule(id: string): void {
    this.subscription.add(
      this.service.view('vehicules', id)
        .subscribe(arg => {
          this.v = arg;
          this.loading = false;
        }, erg => {
          this.errorLoading = 'Erreur de changement';
          this.loading = false;
        })
    );
  }
  open(c: any): void {
    this.modal.open(c);
  }

  createForm(): void {
    this.form = this.fb.group({
      chauffeur: ['', Validators.required],
      mobile: ['', Validators.required],
      permis: ['', Validators.required],
      piece: ['']

    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.subscription.add(
      this.service.update('chauffeurs', this.id, this.form.value)
        .subscribe(
          arg => {
            this.getVehicule(this.id);
            this.modal.dismissAll();
          },
          erg => {
            this.errorMsg = erg.error.message;
            this.submitted = false;
          })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


}
